/**
 * sendFamilyBroadcast - Browser script to send email broadcasts to parents
 *
 * Usage:
 *   await window.sendFamilyBroadcast({
 *     subject: "Parent Evening Reminder",
 *     body: "Dear Parent, please note...",
 *     classIds: ["7C", "8A"],  // optional filter
 *     grades: ["7", "8"],      // optional filter
 *   })
 */
import { httpsCallable } from 'firebase/functions';
import { functions, auth } from '../firebase';

export async function sendFamilyBroadcast(options = {}) {
  console.log('='.repeat(60));
  console.log('FAMILY BROADCAST');
  console.log('='.repeat(60));

  const user = auth.currentUser;
  if (!user) {
    console.error('Not logged in');
    return;
  }

  const { subject, body, classIds, grades } = options;

  if (!subject || !body) {
    console.error('subject and body are required');
    console.log('Usage: await window.sendFamilyBroadcast({ subject: "...", body: "...", classIds: ["7C"] })');
    return;
  }

  const schoolContext = JSON.parse(localStorage.getItem('schoolContext') || '{}');
  const schoolId = schoolContext.schoolId;
  if (!schoolId) {
    console.error('No school context found');
    return;
  }

  // Build filter
  const filter = {};
  if (classIds && classIds.length > 0) filter.classIds = classIds;
  if (grades && grades.length > 0) filter.grades = grades;

  console.log(`School: ${schoolId}`);
  console.log(`Subject: ${subject}`);
  console.log(`Filter:`, Object.keys(filter).length > 0 ? filter : 'none (all parents)');

  try {
    const fn = httpsCallable(functions, 'sendFamilyBroadcast');
    const result = await fn({ schoolId, subject, body, filter });

    console.log('='.repeat(60));
    console.log('BROADCAST RESULT');
    console.log(`  Emails sent: ${result.data.sent}`);
    console.log(`  Emails failed: ${result.data.failed}`);
    console.log(`  Family cards matched: ${result.data.totalCards}`);
    if (result.data.errors) {
      console.warn('  Errors:', result.data.errors);
    }
    console.log('='.repeat(60));

    return result.data;
  } catch (err) {
    console.error('Broadcast failed:', err.message);
    return null;
  }
}
